import React from 'react';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';

function Grid() {
    return (
        <div>
<Container fluid className="col">
  <Row>
    <Col>Copyright@TechnoFarmers</Col>
  </Row>
</Container> 
        </div>
    )
}

export default Grid;
